import { config } from 'src/core/config';
import { FormInfo } from './DynamicForm/dynamic-form';

// Using same regex as email check constraint in DB
export const EMAIL_VALIDATION_REGEX = /^[A-Za-z0-9.#_%+!-]+@[A-Za-z0-9.-]+[.][A-Za-z]+$/;
export const DOMAIN_VALIDATION_REGEX = /^[A-Za-z0-9.-]+[.][A-Za-z]+$/;
export const AT_LEAST_TEN_CHARACTERS = /^(?=.{10,})/;
export const AT_LEAST_ONE_NUMBER = /(?=.*\d)/;
export const AT_LEAST_ONE_LOWER_CASE = /(?=.*[a-z])/;
export const AT_LEAST_ONE_UPPER_CASE = /(?=.*[A-Z])/;
export const INTERNAL_EMAIL_VALIDATION_REGEX = new RegExp(
  `^[A-Za-z0-9.#_%+!-]+@${config.clientFacingDomainName}$`,
);

/**
 * Checks the presence of the following characters:
 * ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ ` + =
 */

// eslint-disable-next-line no-useless-escape
export const AT_LEAST_ONE_SPECIAL_CHARACTER = /[\^$*.\[\]{}()?"!@#%&\/\\,><'':;|_~`+=-]/;
export const MIN_NUMBER_LENGTH = 10;
export const MAX_NUMBER_LENGTH = 12;

export function formHasChanges<T>({
  formState,
  info,
  defaultValues,
  values,
}: FormInfo<T> & { values: T }) {
  const modifiedFieldName = info?.name;

  return (
    formState?.isDirty ||
    (modifiedFieldName &&
      JSON.stringify(values[modifiedFieldName as keyof T]) !==
        JSON.stringify(defaultValues?.[modifiedFieldName as keyof T]))
  );
}

export function validatePhone(phone?: number | string) {
  if (!phone) {
    return false;
  }

  return (
    phone.toString().length >= MIN_NUMBER_LENGTH &&
    phone.toString().length <= MAX_NUMBER_LENGTH &&
    !Number.isNaN(parseInt(phone.toString()))
  );
}

export function validateEmail(email?: string) {
  if (!email) {
    return false;
  }

  return EMAIL_VALIDATION_REGEX.test(email);
}
